import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Icon from '../../components/AppIcon';
import { getExperimentVisitorId, resolveExperiment } from '../../services/abExperimentTracking';

const ExperimentRouter = () => {
  const { testId } = useParams();
  const navigate = useNavigate();
  const [error, setError] = useState(null);

  useEffect(() => {
    let active = true;
    const routeVisitor = async () => {
      try {
        const assignment = await resolveExperiment(testId);
        if (!active) return;
        const params = new URLSearchParams({
          ab_test: testId,
          ab_variant: assignment.variantId,
          ab_visitor: getExperimentVisitorId(),
        });
        navigate(`/${assignment.formId}?${params.toString()}`, { replace: true });
      } catch (err) {
        if (active) setError(err?.message || 'This experiment is unavailable.');
      }
    };
    routeVisitor();
    return () => { active = false; };
  }, [navigate, testId]);

  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-4">
      <div className="max-w-md text-center">
        {error ? (
          <>
            <Icon name="CircleAlert" size={40} className="mx-auto mb-4 text-destructive" />
            <h1 className="text-xl font-semibold text-foreground">Experiment unavailable</h1>
            <p className="mt-2 text-sm text-muted-foreground">{error}</p>
          </>
        ) : (
          <>
            <Icon name="Loader2" size={40} className="mx-auto mb-4 text-primary animate-spin" />
            <p className="text-sm text-muted-foreground">Loading your form…</p>
          </>
        )}
      </div>
    </div>
  );
};

export default ExperimentRouter;